import {
  AuthorizationAPIClient,
  AuthorizationStorage,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'
import { ref, Ref } from 'vue'

export interface AuthorizationSAMLUseCase {
  loading: Ref<boolean>
  login: () => void
  continueLoginProcess: (requestId: string, applicationId?: string) => Promise<void>
}

const useSAMLLogin = (
  authorizationStorage: AuthorizationStorage,
  samlApiClient: AuthorizationAPIClient): AuthorizationSAMLUseCase => {

  const loading = ref(false)
  const login = () => {
    const url = window.location.href
    const urlObj = new URL(url)
    urlObj.searchParams.delete('request_id')

    const encodedURI = encodeURIComponent(urlObj.toString())
    const redirectUri = `${API_URL}/saml/?redirect_to=${encodedURI}` 
    window.location.replace(redirectUri)
  }

  const continueLoginProcess = async (requestId: string, applicationId?: string) => {
    loading.value = true
    const payload = { 
      request_id: requestId,
      webapp: applicationId,
    }
    try {
      const token = await samlApiClient.login(payload)
      authorizationStorage.set(token)
    } finally {
      loading.value = false
    }
  }
  return {
    loading,
    login,
    continueLoginProcess,
  }
}

export default useSAMLLogin
